import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getUserNotificationMessages = (state: IRootState) => state.userNotification.data;
export const getUserNotificationMessagesTotalCount = (state: IRootState) => state.userNotification.totalCount;
export const getUserNotificationUnreadCount = (state: IRootState) => state.userNotification.unReadNotificationCount;
export const getReadTypeSelectOption = (state: IRootState) => state.userNotification.searchTypeSelectOption;
export const getUserNotificationSettings = (state: IRootState) => state.userNotification.settings;
export const getUserNotificationSearchText = (state: IRootState) => state.userNotification.searchText;
export const getUserNotificationPage = (state: IRootState) => state.userNotification.page;
